export type IdentityTransition =
  | {action: 'none'}
  | {action: 'identify'; did: string}
  | {action: 'reset'}

export function getIdentityTransition(
  prevDid: string | undefined,
  nextDid: string | undefined,
): IdentityTransition {
  if (prevDid === nextDid) {
    return {action: 'none'}
  }
  if (nextDid) {
    return {action: 'identify', did: nextDid}
  }
  if (prevDid) {
    return {action: 'reset'}
  }
  return {action: 'none'}
}
